export default __webpack_public_path__ + "images/29fa526b0bf9cb23e35a5ba52794fd6c.png";